import { Box, Container, Typography } from "@mui/material";
import React from "react";
import LostImage from "../../../assets/svgs/404.svg";

function PageNotFound() {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          height: "400px",
          width: "400px",
          overflow: "hidden",
          backgroundImage: `url(${LostImage})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Typography fontSize={"3rem"} fontWeight={700}>
        404
      </Typography>
      <Typography fontSize={"1rem"} fontWeight={400}>
        Page not found
      </Typography>
    </Container>
  );
}

export default PageNotFound;
